module.exports = __webpack_public_path__ + "static/media/arrow-back-white.65abd7a8.svg";